<div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto">
    <div style="padding-left: 15px;" class="col-12 no-gutters">
        <app-layout-header class="col-12 no-gutters"></app-layout-header>
    </div>
    <div class="col-12 text-title" *ngIf="isShow">
        <h1>SUPPLIERS</h1>
    </div>
    <br>
    <div class="row no-gutters col-12 justify-content-center" *ngIf="isShow">
        <div class="col-md-12 col-xl-7 pr-xl-3">
            <div class="text-header py-2">Powerful Relationships</div>
            <div class="col-12 no-px text-normal">At GE Vernova, we recognize that our suppliers are critical
                partners, and play
                a vital role
                in
                the creation of our world-class solutions. We're happy to provide all of our suppliers with tools and
                services to make you more efficient, knowledgeable, and above all, help to sustain a close, productive
                relationship with GE.</div>
            <div class="py-3 no-px col-12">
                <img class="margin-left-img" src="../../../../../assets/images/supplier-portal-cover2.jpg" alt="">
            </div>
        </div>
        <div class="col-md-12 col-xl-5">
            <div class="border-box-help px-layout mb-2">
                <div class="text-header-help"><h2>Need Help?</h2></div>
                <div class="row no-gutters col-12 pb-1 no-px text-normal">
                    The eSourcing Helpdesk is happy to help. You can email us at<br/>
                    <span><a style="color: #005E60 !important; background-color: #C8FF08 !important;" href="mailto:GERenEnergy.SupplierSupport@ge.com">~GE Vernova Supplier Support</a>
                </span>
                </div>
            </div>
            <div class="border-box-help px-layout">
                <div class="text-header-help"><h2>Stay Informed</h2></div>
                <div class="row no-gutters col-12 pb-1 no-px text-normal">
                    Access GE Vernova’s many resources regarding supply chain policies, quality and learning.
                </div>
                <div *ngFor="let item of listStayInformed; let last = last" class="no-px text-normal-help"
                    [ngClass]="last ? 'pt-2' : 'border-bottom py-2'">
                    <a class="text-normal-hyperlink d-flex"
                        (click)="windowOpen(item?.url ? item?.url : item?.resource?.resourceUrl)">
                        <img [src]="item?.type === 'LINK' ? '../../../../../assets/images/link.svg' : '../../../../../assets/images/google-docs.svg'" alt="" class="pr-2" width="20" height="20">
                        <div class="text-left">{{item?.name}}</div>
                    </a>
                </div>
            </div>
            <div class="paging">
                <ng-container *ngIf="totalPages <= 5">
                  <div *ngFor="let item of counter(totalPages); let i = index" class="circle-number" (click)="paging(i)"
                    [ngClass]="{'select-page': i === page}">
                    <span>{{i + 1}}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="totalPages > 5">
                  <div class="circle-number" (click)="paging(0)" [ngClass]="{'select-page': page === 0}">
                    <span>1</span>
                  </div>
                  <div *ngIf="page > 2">...</div>
                  <ng-container *ngIf="page <= 1">
                    <div class="circle-number" (click)="paging(1)" [ngClass]="{'select-page': page === 1}">
                      <span>2</span>
                    </div>
                    <div class="circle-number" (click)="paging(2)" [ngClass]="{'select-page': page === 2}">
                      <span>3</span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="page > 1 && page < totalPages - 2">
                    <div class="circle-number" (click)="paging(page - 1)">
                      <span>{{page}}</span>
                    </div>
                    <div class="circle-number select-page" (click)="paging(page)">
                      <span>{{page + 1}}</span>
                    </div>
                    <div class="circle-number" (click)="paging(page + 1)">
                      <span>{{page + 2}}</span>
                    </div>
                  </ng-container>
                  
                  <div *ngIf="page < totalPages - 3">...</div>
                  <ng-container *ngIf="page >= totalPages - 2">
                    <div class="circle-number" (click)="paging(totalPages - 3)" [ngClass]="{'select-page': page === totalPages - 3}">
                      <span>{{totalPages - 2}}</span>
                    </div>
                    <div class="circle-number" (click)="paging(totalPages - 2)" [ngClass]="{'select-page': page === totalPages - 2}">
                      <span>{{totalPages - 1}}</span>
                    </div>
                  </ng-container>
                  <div class="circle-number" (click)="paging(totalPages - 1)" [ngClass]="{'select-page': page === totalPages - 1}">
                    <span>{{totalPages}}</span>
                  </div>
                </ng-container>
              </div>
        </div>
    </div>
    <div class="row no-gutters col-12 justify-content-center" *ngIf="isShow">
        <div class="col-md-12 col-xl-12 pr-xl-3">
            <div class="text-header py-2">Applications And Tools For Suppliers</div>
            <div class="col-12 no-px text-normal">Using our range of robust tools, suppliers can access all relevant
                areas of
                GE Vernova
                including
                sourcing, purchasing, finance, engineering, production control and logistics. Using our tools, suppliers
                can:</div>
            <br>
            <div class="row no-gutters col-12 no-px">
                <!-- <div class="col-12 col-sm-1 col-md-1 col-xl-1 item-center"></div> -->
                <!-- <div class="col-12 col-sm-2 col-md-2 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size">
                        <div class="p-3"><img src="../../../../../assets/images/folder.svg" alt="" height="40"
                                width="40">
                        </div>
                        <div class="px-3 text-normal item-center">Reduce cycle time by accessing timely information
                        </div>
                    </div>
                </div> -->
                <!-- <div class="col-12 col-sm-2 col-md-2 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size">
                        <div class="p-3"><img src="../../../../../assets/images/phone.svg" alt="" height="40"
                                width="40">
                        </div>
                        <div class="px-3 text-normal item-center">Create and review invoices and purchase orders easily
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-2 col-md-2 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size">
                        <div class="p-3"><img src="../../../../../assets/images/time.svg" alt="" height="40" width="40">
                        </div>
                        <div class="px-3 text-normal item-center">Conduct business 24x7 at your convenience</div>
                    </div>
                </div>
                <div class="col-12 col-sm-2 col-md-2 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size">
                        <div class="p-3"><img src="../../../../../assets/images/money-2.svg" alt="" height="40"
                                width="40">
                        </div>
                        <div class="px-3 text-normal item-center">Reduce operational costs by streamlining processes
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-2 col-md-2 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size">
                        <div class="p-3"><img src="../../../../../assets/images/visibility.svg" alt="" height="40"
                                width="40">
                        </div>
                        <div class="px-3 text-normal item-center">Access information about our sourcing requirements
                        </div>
                    </div>
                </div> -->
                <div class="col-0 col-sm-0 col-md-0 col-xl-1 item-center"></div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size d-flex align-items-center">
                      <div class="p-2">
                        <img alt="" height="40" src="../../../../../assets/images/folder.svg" width="40">
                      </div>
                      <div class="flex-grow-1 px-2 text-normal-tool">
                        Reduce cycle time by accessing timely information
                      </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size d-flex align-items-center">
                      <div class="p-2">
                        <img alt="" height="40" src="../../../../../assets/images/phone.svg" width="40">
                      </div>
                      <div class="flex-grow-1 px-2 text-normal-tool">
                        Create and review invoices and purchase orders easily
                      </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size d-flex align-items-center">
                      <div class="p-2">
                        <img alt="" height="40" src="../../../../../assets/images/time.svg" width="40">
                      </div>
                      <div class="flex-grow-1 px-2 text-normal-tool">
                        Conduct business 24x7 at your convenience
                      </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size d-flex align-items-center">
                      <div class="p-2">
                        <img alt="" height="40" src="../../../../../assets/images/money-2.svg" width="40">
                      </div>
                      <div class="flex-grow-1 px-2 text-normal-tool">
                        Reduce operational costs by streamlining processes
                      </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2 item-center">
                    <div class="border-box m-2 border-box-size d-flex align-items-center">
                      <div class="p-2">
                        <img alt="" height="40" src="../../../../../assets/images/visibility.svg" width="40">
                      </div>
                      <div class="flex-grow-1 px-2 text-normal-tool">
                        Access information about our sourcing requirements
                      </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="col-12 no-px text-normal">
                <p>How to get access to GE Applications?</p>
                <p class="m-0 p-0 ml-4">1. The first step is to request a GE Single Sign On account. Please use following link to request a SSO if you do not have one and need access to the tools.</p>
                <div class="mb-2 py-2 px-4 d-flex">
                  <a href="https://registration.gepower.com" target="_blank" class="text-normal-hyperlink">
                      <i class="fa fa-send-o pr-3"></i>
                  </a>
                  <a href="https://registration.gepower.com" target="_blank" class="text-normal-hyperlink text-left" style="background-color: #C8FF08 !important;">
                      Request GE Single Sign On Or Application Access
                  </a>
                </div>
              <p class="ml-4">2. After your SSO is created, from the Menu bar, go to <span style="font-weight: bold;">REN Supplier Portal > Application Request Access</span> and request access to the required application.</p>
            </div>
            <div class="border-box-help my-2">
                <div class="py-2 px-4 d-flex" *ngIf="!userName">
                    <a href="/login" class="text-normal-hyperlink">
                        <i class="fa fa-sign-in pr-3 size-icon"></i>
                    </a>
                    <a href="/login" class="text-normal-hyperlink text-left" style="background-color: #C8FF08 !important;">
                        Sign In with GE SSO
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer-layout *ngIf="isShow"></app-footer-layout>